import React from 'react';
import { FaShieldAlt, FaHandshake, FaUsers, FaMapMarkerAlt, FaGraduationCap, FaHome, FaFileAlt, FaEuroSign, FaRocket, FaStar } from 'react-icons/fa';
import heroImage from '../../assets/images/16256199_June83-removebg-preview.png';
import './CompanyPresentation.css';

const CompanyPresentation = () => {
  const values = [
    {
      icon: <FaShieldAlt />,
      title: "Confiance & Sécurité",
      description: "Votre réussite est notre priorité absolue"
    },
    {
      icon: <FaHandshake />,
      title: "Accompagnement personnalisé",
      description: "Un suivi individualisé à chaque étape"
    },
    {
      icon: <FaUsers />,
      title: "Expertise Collective",
      description: "Une équipe expérimentée à votre service"
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Intégration facile",
      description: "Nous vous aidons à vous installer en France"
    }
  ];

  const services = [
    {
      icon: <FaGraduationCap />,
      title: "Admission ",
      description: "Le choix et l'admission dans les établissements français",
      color: '#073b8f'
    },
    {
      icon: <FaHome />,
      title: "Logement ",
      description: "La recherche et la réservation de logement étudiant",
      color: '#c0264a'
    },
    {
      icon: <FaFileAlt />,
      title: "Dossier de visa",
      description: "La préparation complète du dossier de visa",
      color: '#073b8f'
    },
    {
      icon: <FaEuroSign />,
      title: "Attestation AVI",
      description: "L'obtention de l'Attestation de Virement Irrévocable (AVI)",
      color: '#c0264a'
    }
  ];

  return (
    <section className="btg-company-presentation-dark" id="btg-company">
      <div className="btg-container-dark">
        {/* En-tête de section - Style sombre premium */}
        <div className="btg-company-header-dark">
          <div className="btg-header-content-dark">
            <div className="btg-header-badge">
              <FaRocket className="btg-badge-icon" />
              <span>BTG CONSEIL</span>
            </div>
            <h1 className="btg-main-title-dark">Votre partenaire de confiance</h1>
            <p className="btg-main-subtitle-dark">Spécialistes de l'accompagnement des étudiants</p>
            <p className="btg-section-subtitle-dark">
              Nous transformons les rêves d'études en France en réalités tangibles grâce à notre expertise et notre accompagnement personnalisé
            </p>
            <div className="btg-header-decoration-dark">
              <div className="btg-decoration-line-dark"></div>
              <div className="btg-decoration-dot-dark"></div>
              <div className="btg-decoration-glow-dark"></div>
              <div className="btg-decoration-dot-dark"></div>
              <div className="btg-decoration-line-dark"></div>
            </div>
          </div>
        </div>

        {/* Section services horizontaux sombre */}
        <div className="btg-services-horizontal-dark">
          <div className="btg-services-wrapper-dark">
            <h2 className="btg-services-main-title-dark">Nos domaines d'expertise</h2>
            <div className="btg-services-cards-grid-dark">
              {services.map((service, index) => (
                <div 
                  key={index} 
                  className="btg-service-horizontal-card-dark"
                  style={{ '--btg-accent-color': service.color }}
                >
                  <div className="btg-card-glow" style={{ '--glow-color': service.color }}></div>
                  
                  <div className="btg-service-horizontal-content-dark">
                    <div className="btg-service-icon-container-dark">
                      <div className="btg-service-main-icon-dark">
                        {service.icon}
                      </div>
                      <div className="btg-icon-glow"></div>
                    </div>
                    <h3 className="btg-service-card-title-dark">{service.title}</h3>
                    <p className="btg-service-card-description-dark">{service.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Main Content Grid */}
        <div className="btg-main-content-grid-dark">
          {/* Text Content */}
          <div className="btg-content-left-dark">
            <div className="btg-mission-card-dark">
              <div className="btg-card-header-dark">
                <div className="btg-icon-wrapper btg-mission-icon-dark">
                  <FaGraduationCap />
                </div>
                <h2>Notre mission</h2>
              </div>
              <p>
                Chez <strong>BTG CONSEIL</strong>, nous transformons les rêves d'études en France 
                en réalités tangibles. Notre équipe dévouée vous guide à travers chaque étape 
                de votre projet académique, de la conception à la concrétisation.
              </p>
            </div>

            <div className="btg-expertise-card-dark">
              <div className="btg-card-header-dark">
                <div className="btg-icon-wrapper btg-expertise-icon-dark">
                  <FaUsers />
                </div>
                <h2>Notre expertise</h2>
              </div>
              <p>
                Forts de notre connaissance approfondie du système éducatif français 
                et des procédures administratives, nous vous offrons un accompagnement 
                sur mesure pour réussir votre intégration en France.
              </p>
            </div>
          </div>

          {/* Image Section */}
          <div className="btg-content-right-dark">
            <div className="btg-image-container-dark">
              <div className="btg-main-image-wrapper-dark">
                <img 
                  src={heroImage}
                  alt="Étudiants BTG CONSEIL en France"
                  className="btg-main-image-dark"
                />
                <div className="btg-image-overlay-dark"></div>
                <div className="btg-floating-badge-dark">
                  <span>+500</span>
                  <small>Étudiants accompagnés</small>
                </div>
              </div>
              
              {/* Image Stats */}
              <div className="btg-image-stats-dark">
                <div className="btg-stat-item-dark">
                  <div className="btg-stat-number-dark">98%</div>
                  <div className="btg-stat-label-dark">Taux de réussite</div>
                </div>
                <div className="btg-stat-item-dark">
                  <div className="btg-stat-number-dark">50+</div>
                  <div className="btg-stat-label-dark">Universités partenaires</div>
                </div>
                <div className="btg-stat-item-dark">
                  <div className="btg-stat-number-dark">24h</div>
                  <div className="btg-stat-label-dark">Support rapide</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Values Section */}
        <div className="btg-values-section-dark">
          <div className="btg-values-header-dark">
            <div className="btg-values-header-content-dark">
              <h2 className="btg-values-main-title-dark">Nos valeurs</h2>
              <p className="btg-values-subtitle-dark">Ce qui fait notre différence</p>
              <div className="btg-values-header-decoration-dark">
                <div className="btg-values-decoration-line-dark"></div>
                <div className="btg-values-decoration-dot-dark"></div>
                <div className="btg-values-decoration-line-dark"></div>
              </div>
            </div>
          </div>
          <div className="btg-values-grid-dark">
            {values.map((value, index) => (
              <div key={index} className="btg-value-card-dark">
                <div className="btg-value-icon-wrapper-dark">
                  {value.icon}
                </div>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className="btg-company-cta-dark">
          <div className="btg-cta-content-dark">
            <div className="btg-cta-header-dark">
              <h3 className="btg-cta-title-dark">Prêt à commencer votre aventure en France ?</h3>
              <p className="btg-cta-subtitle-dark">Rejoignez les centaines d'étudiants qui nous font confiance</p>
            </div>
            <p className="btg-cta-text-dark">
              Votre avenir en France commence ici. Notre équipe d'experts vous accompagne à chaque étape de votre projet.
            </p>
            <button className="btg-cta-button-dark">
              <FaRocket className="btg-cta-icon" />
              Commencer maintenant
              <div className="btg-button-glow"></div>
            </button>
            
            <div className="btg-cta-stats-dark">
              <div className="btg-stat-dark">
                <div className="btg-stat-number-dark">500+</div>
                <div className="btg-stat-label-dark">Étudiants accompagnés</div>
              </div>
              <div className="btg-stat-dark">
                <div className="btg-stat-number-dark">95%</div>
                <div className="btg-stat-label-dark">Taux de réussite</div>
              </div>
              <div className="btg-stat-dark">
                <div className="btg-stat-number-dark">98%</div>
                <div className="btg-stat-label-dark">Satisfaction</div>
              </div>
            </div>
          </div>
          
          {/* Background animé pour le CTA */}
          <div className="btg-cta-background-dark">
            <div className="btg-cta-particle"></div>
            <div className="btg-cta-particle"></div>
            <div className="btg-cta-particle"></div>
          </div>
        </div>
      </div>

      {/* Background éléments décoratifs */}
      <div className="btg-background-elements">
        <div className="btg-bg-element btg-bg-1"></div>
        <div className="btg-bg-element btg-bg-2"></div>
        <div className="btg-bg-element btg-bg-3"></div>
        <div className="btg-bg-element btg-bg-4"></div>
      </div>
    </section>
  );
};

export default CompanyPresentation;